module.exports = __webpack_public_path__ + "img/首图.png.bb7e7855.png";